import { fatalLog } from 'logging';
import React, { ReactNode, useEffect } from 'react';

interface GlobalErrorHandlerProps {
  children: ReactNode;
}

const GlobalErrorHandler: React.FC<GlobalErrorHandlerProps> = ({ children }) => {
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      const error = event.error || new Error(event.message);
      console.error('Global error:', error);
      fatalLog('Uncaught runtime errors:', error);
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      const reason = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
      console.error('Unhandled promise rejection:', reason);
      fatalLog('Unhandled promise rejection:', reason);
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return <>{children}</>;
};

export default GlobalErrorHandler;
